export const CENTROS = [
  'HERNANI',
  'QUEVEDO',
  'GOYA',
  'ESQUERDO',
  'LOPEZ DE HOYOS',
  'ALCOBENDAS',
  'POZUELO',
  'VALLADOLID',
  'ALCALA',
  'MAJADAHONDA',
  'ALCORCON',
  'DELICIAS',
  'TORREJON',
  'MIRASIERRA',
  'REYES CATOLICOS',
  'CLASSFY'
]
export const CENTROS_CERRADOS = ['RETIRO', 'CORDOBA']

export const isClassfy = centro => centro === 'CLASSFY'
